<template>
  <div class="box !p-0 box-25 last:mr-0 relative w-full">
    <div class="flex flex-wrap">
      <div class="flex flex-col items-center justify-center min-w-[75px] max-w-[75px] p-2 bg-g3">
        <svg width="25px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.13 53.07">
          <path
            d="M7.49,15.57l26.86,26.86,19.31-11.84L23.06,0,7.49,15.57ZM30.79,18.84l-9-9,1.56-1.56,9,9-1.56,1.56ZM0,24.86v28.22s3.62,0,3.62,0v-12.3h9.51s4.93-4.93,4.93-4.93c.66.3,1.38.47,2.13.47,1.38,0,2.67-.54,3.65-1.51l-7.3-7.3c-1.56,1.56-1.9,3.87-1.03,5.78l-3.87,3.87H3.62v-12.3s-3.62,0-3.62,0ZM50.95,34.55l-11.05,6.78,2.32,2.32,13.91-3.91-5.18-5.18Z"
            style="fill:#fff; stroke-width:0px;" />
        </svg>
        <span class="text-center text-balance leading-3 mt-3">
          {{ config.deviceFamilly.this_name }}
        </span>
      </div>
      <Videos_Externe :config="config" />
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import Videos_Externe from "@/partials/Video/Videos_Externe.vue";
export default {
  name: "WatchCam_Temporaire",
  components: {
    Videos_Externe,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
    };
  },

  async mounted() {

  },

  methods: {

  },
};
</script>
